import { PaymentMethod } from '../enums/payment-method.enum';
import { UtilHelper } from '../helpers/utils.helper';

export class StorePaymentMethod {
  accepted: boolean;
  type: PaymentMethod;
  brands: string[];

  //aux view
  brandsAvailable: CardBrand[];
  newBrand: string;
  showInputNewBrand: boolean;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.type != null && this.type['code'] == null) {
      this.type = UtilHelper.getEnumByCod(this.type, PaymentMethod);
    }
    if (!this.brands) this.brands = [];

    this.brandsAvailable = this.getBrandsForPaymentMethod(this.type);
    this.brandsAvailable.forEach((b) => {
      b.accepted = this.brands.find((item) => item.toLowerCase() == b.name.toLowerCase()) != null;
    });
    // Adiciona as bandeiras que não pré-existe, mas está salvo
    this.brands.forEach((b) => {
      if (!this.brandsAvailable.find((item) => item.name.toLowerCase() == b.toLowerCase())) {
        this.brandsAvailable.push({ name: b, accepted: true });
      }
    });
  }

  private getBrandsForPaymentMethod(paymentMethod: PaymentMethod): CardBrand[] {
    if (!paymentMethod) return [];

    switch (paymentMethod) {
      case PaymentMethod.LOCAL_CREDIT_CARD:
        return this.getBrandsCreditCard();
      case PaymentMethod.LOCAL_DEBIT_CARD:
        return this.getBrandsDebitCard();
      case PaymentMethod.LOCAL_MEAL_TICKET:
        return this.getBrandsMealCard();
      default:
        return [];
    }
  }

  private getBrandsCreditCard(): CardBrand[] {
    return [
      { name: 'Visa', accepted: false },
      { name: 'MasterCard', accepted: false },
      { name: 'American Express', accepted: false },
      { name: 'Elo', accepted: false },
      { name: 'Diners Club', accepted: false },
      { name: 'Hipercard', accepted: false },
    ];
  }

  private getBrandsDebitCard(): CardBrand[] {
    return [
      { name: 'Visa', accepted: false },
      { name: 'MasterCard', accepted: false },
      { name: 'Elo', accepted: false },
    ];
  }

  private getBrandsMealCard(): CardBrand[] {
    return [
      { name: 'Sodexo', accepted: false },
      { name: 'Alelo', accepted: false },
      { name: 'VR', accepted: false },
      { name: 'Ticket', accepted: false },
      { name: 'Green Card', accepted: false },
      { name: 'Ben', accepted: false },
    ];
  }
}

export class StorePaymentMethodsOptions {
  online: StorePaymentMethod[];
  local: StorePaymentMethod[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (!this.online) this.online = [];
    if (!this.local) this.local = [];
  }

  toJson(): any {
    let json = { online: [], local: [] };
    this.online.forEach((o) => {
      json.online.push({
        accepted: o.accepted,
        type: o.type['code'],
      });
    });
    this.local.forEach((o) => {
      json.local.push({
        accepted: o.accepted,
        type: o.type['code'],
        brands: o.accepted ? o.brands : [],
      });
    });
    return json;
  }
}

export interface CardBrand {
  name: string;
  accepted: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/payment-method.model.ts